var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("breadcrumb-top", { attrs: { breadcrumbConfig: _vm.dataList } }),
      _c("div", { staticClass: "content" }, [
        _c("h2", [_vm._v("商品审核")]),
        _c("h3", [_vm._v("数据筛选")]),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "searchForm",
                staticClass: "search-form",
                attrs: { inline: true, model: _vm.searchForm, size: "small" },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "申请平台", prop: "goodsType" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择申请平台",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.platformId,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "platformId", $$v)
                          },
                          expression: "searchForm.platformId",
                        },
                      },
                      _vm._l(_vm.platformList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.name, value: item.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "商品编号", prop: "goodsNo" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入商品编号" },
                      model: {
                        value: _vm.searchForm.goodsNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "goodsNo", $$v)
                        },
                        expression: "searchForm.goodsNo",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "商品名称", prop: "name" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入商品名称", clearable: "" },
                      model: {
                        value: _vm.searchForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "name", $$v)
                        },
                        expression: "searchForm.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "商品类目", prop: "categoryId" } },
                  [
                    _c("el-cascader", {
                      attrs: {
                        options: _vm.categoryList,
                        props: { checkStrictly: true },
                        filterable: "",
                        clearable: "",
                      },
                      on: { change: _vm.onChangeCategory },
                      model: {
                        value: _vm.searchForm.categoryId,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "categoryId", $$v)
                        },
                        expression: "searchForm.categoryId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "商品类型", prop: "type" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择商品类型",
                          filterable: "",
                          clearableb: "",
                          multiple: "",
                          "collapse-tags": "",
                        },
                        model: {
                          value: _vm.searchForm.goodsTypes,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "goodsTypes", $$v)
                          },
                          expression: "searchForm.goodsTypes",
                        },
                      },
                      _vm._l(_vm.dictionaries.goods_type, function (item) {
                        return _c("el-option", {
                          key: item.dictId,
                          attrs: { label: item.dictName, value: item.dictId },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "申请类型", prop: "goodsType" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择申请类型",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.goodsVerifyType,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "goodsVerifyType", $$v)
                          },
                          expression: "searchForm.goodsVerifyType",
                        },
                      },
                      _vm._l(
                        _vm.dictionaries.goods_verify_type,
                        function (item) {
                          return _c("el-option", {
                            key: item.dictId,
                            attrs: { label: item.dictName, value: item.dictId },
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "平台商品编号", prop: "goodsNo" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入平台商品编号" },
                      model: {
                        value: _vm.searchForm.platformGoodsNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "platformGoodsNo", $$v)
                        },
                        expression: "searchForm.platformGoodsNo",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "状态", prop: "verifyStatus" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择状态", clearable: "" },
                        on: { change: _vm.selectStatus },
                        model: {
                          value: _vm.searchForm.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "status", $$v)
                          },
                          expression: "searchForm.status",
                        },
                      },
                      _vm._l(
                        _vm.dictionaries.goods_verify_status,
                        function (item) {
                          return _c("el-option", {
                            key: item.dictId,
                            attrs: { label: item.dictName, value: item.dictId },
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "申请时间" } },
                  [
                    _c(
                      "el-date-picker",
                      {
                        attrs: {
                          type: "daterange",
                          "unlink-panels": "",
                          clearable: "",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "default-time": ["00:00:00", "23:59:59"],
                        },
                        on: { change: _vm.onChangeApplyData },
                        model: {
                          value: _vm.searchForm.applyDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "applyDate", $$v)
                          },
                          expression: "searchForm.applyDate",
                        },
                      },
                      [_vm._v(" > ")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "审核时间" } },
                  [
                    _c(
                      "el-date-picker",
                      {
                        attrs: {
                          type: "daterange",
                          "unlink-panels": "",
                          clearable: "",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "default-time": ["00:00:00", "23:59:59"],
                        },
                        on: { change: _vm.onChangeVerifyData },
                        model: {
                          value: _vm.searchForm.verifyDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "verifyDate", $$v)
                          },
                          expression: "searchForm.verifyDate",
                        },
                      },
                      [_vm._v(" > ")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "商品外部编号", prop: "outGoodsNo" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入商品外部编号" },
                      model: {
                        value: _vm.searchForm.outGoodsNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "outGoodsNo", $$v)
                        },
                        expression: "searchForm.outGoodsNo",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-left": "24px" },
                    attrs: { label: "" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("search")
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("reset")
                          },
                        },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "content" }, [
        _c("h3", [_vm._v("列表数据")]),
        _c("div", { staticClass: "btn-list" }, [
          _c(
            "div",
            { staticClass: "item" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    plain: "",
                    type: _vm.currentStatus === 1 ? "primary" : "info",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onChangeList(1)
                    },
                  },
                },
                [
                  _vm._v(
                    "全部(" + _vm._s(_vm.countGroupByStatus.totalCount) + ")"
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    plain: "",
                    type: _vm.currentStatus === 2 ? "primary" : "info",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onChangeList(2)
                    },
                  },
                },
                [
                  _vm._v(
                    "待审核(" + _vm._s(_vm.countGroupByStatus.waitVerify) + ")"
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    plain: "",
                    type: _vm.currentStatus === 3 ? "primary" : "info",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onChangeList(3)
                    },
                  },
                },
                [
                  _vm._v(
                    "已通过(" + _vm._s(_vm.countGroupByStatus.passVerify) + ")"
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    plain: "",
                    type: _vm.currentStatus === 4 ? "primary" : "info",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onChangeList(4)
                    },
                  },
                },
                [
                  _vm._v(
                    "已驳回(" + _vm._s(_vm.countGroupByStatus.failVerify) + ")"
                  ),
                ]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "item" }),
        ]),
        _c(
          "div",
          { attrs: { id: "base-list" } },
          [
            _c("lb-table", {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
                {
                  name: "horizontal-scroll",
                  rawName: "v-horizontal-scroll",
                  value: "always",
                  expression: "'always'",
                },
              ],
              attrs: {
                column: _vm.columns,
                data: _vm.list,
                pagination: "",
                total: _vm.page.totalNum,
                layout: "total, sizes, prev, pager, next, jumper",
                "page-sizes": [5, 10, 20, 30, 50],
                "current-page": _vm.page.currentPage,
                "page-size": _vm.page.pageSize,
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.page, "currentPage", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.page, "currentPage", $event)
                },
                "selection-change": _vm.onMultipleSelection,
                "size-change": _vm.handleSizeChange,
                "p-current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }